import React, { useState } from 'react'
import { Button, Typography } from 'antd'
import FloatingFeedback from '../../../../FloatingFeedback/FloatingFeedback'
import { track } from 'statsig'
import { STATSIG } from 'statsig/events'

const { Title, Paragraph } = Typography
const FeedbackPanel = FloatingFeedback as React.ComponentType<{
  showFeedback: boolean
  setShowFeedback: (show: boolean) => void
  selectedProduct: string
  selectedFeature: string
  feedbackType: string
}>

const PageHeader: React.FC = () => {
  const [feedbackOpen, setFeedbackOpen] = useState(false)

  return (
    <>
      <div className="um-refactor__header">
        <Title level={2} className="um-refactor__title">
          User Management
        </Title>
        <div className="um-refactor__spacer" />
        <Button
          className="um-refactor__support-btn"
          onClick={() => {
            setFeedbackOpen(true)
            track(STATSIG.COMMON.FEEDBACK, 'open', {
              source: 'support',
            })
          }}
        >
          Support
        </Button>
      </div>
      <Paragraph className="um-refactor__desc">
        You administer more than one organization, so this page shows all of them. Invite users, assign people to any organization you manage, and open a new organization for an additional office — member data stays isolated per organization.
      </Paragraph>
      <FeedbackPanel
        showFeedback={feedbackOpen}
        setShowFeedback={setFeedbackOpen}
        selectedProduct="Management"
        selectedFeature="User management"
        feedbackType="issue"
      />
    </>
  )
}

export default PageHeader
